<script setup lang="ts">
import type {Article} from '~/types/legacy'
import type {Populated} from '~/types/populated'

defineProps<{
  article: Populated<Article>
}>()

const localePath = useLocalePath()
const {formatDate} = useDate()
</script>

<template>
  <NuxtLink
    :to="localePath(`/blog/${article.slug}`)"
    class="group flex h-fit flex-col gap-y-4 rounded-lg p-2 transition hover:bg-black/5"
  >
    <div class="w-full">
      <NuxtImg
        v-if="article.image"
        v-bind="resolveMediaProps(article.image)"
        :width="360"
        :height="240"
        loading="lazy"
        densities="x1 x2"
        fit="cover"
        class="aspect-video w-full min-w-0 rounded object-cover transition bordershadow-gray"
        :class="$attrs.class"
      />
    </div>

    <div class="flex w-full flex-col gap-y-2 px-4 pb-4 pt-2">
      <Paragraph size="small">
        <time class="flex items-center gap-1">
          <div v-if="article.category" class="flex items-center gap-1">
            <span class="font-medium text-main-500">{{ article.category.name }} </span>
            <span>—</span>
          </div>
          {{ article.createdAt ? formatDate(new Date(article?.createdAt)) : '' }}
        </time>
      </Paragraph>
      <Heading as="h2" size="medium" gradient="gray">
        {{ article.title }}
      </Heading>
      <Paragraph size="normal" class="line-clamp-3 overflow-hidden">
        {{ article.description }}
      </Paragraph>
    </div>
  </NuxtLink>
</template>
